import { gql } from "@apollo/client";

const searchSkillsQuery = gql`
  query searchSkills($organizationId: Int) {
    searchSkills(organizationId: $organizationId) {
      __typename
      ... on SkillNode {
        id
        name
        slug
        description
        visibility
      }
      ... on PlatformSkillType {
        # PlatformSkillType.id is a String ("platform:<slug>") while
        # SkillNode.id is a UUID, so they can't share the "id" response key in
        # one union selection. Alias it; loadAllSkills normalizes both into the
        # single SkillItem.id used by the chip + pickers.
        platformId: id
        name
        slug
        description
        visibility
      }
    }
  }
`;

export default searchSkillsQuery;
